// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app'
import { initializeApp } from "firebase/app"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCLbDQfukIhsCxal07QN3bDHMdXzko1CZ8",
  authDomain: "mavrick-1a92d.firebaseapp.com",
  projectId: "mavrick-1a92d",
  storageBucket: "mavrick-1a92d.appspot.com",
  messagingSenderId: "588641997057",
  appId: "1:588641997057:web:02335d56c00b06961ccb00",
  measurementId: "G-TFKR3TBE3Y"

};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

